import { mobileAppReleaseApi } from 'app/services/api';

import { LogoType } from 'constants/ui';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { uploadCompanyImageAction } from './companyBranding.actions';

export const MOBILE_APP_RELEASE_ACTION_TYPE = createNamedActions('mobileAppRelease', {
  GET_MOBILE_APP_RELEASE: 'GET_MOBILE_APP_RELEASE',
  UPDATE_MOBILE_APP_RELEASE: 'UPDATE_MOBILE_APP_RELEASE',
  TURN_ON_MOBILE_APP_RELEASE: 'TURN_ON_MOBILE_APP_RELEASE',
  GET_MOBILE_APP_RELEASE_EVENTS: 'GET_MOBILE_APP_RELEASE_EVENTS',
  GET_IOS_PUSH_CERTIFICATE_STATUS: 'GET_IOS_PUSH_CERTIFICATE_STATUS',
});

export const getMobileAppReleaseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await mobileAppReleaseApi.getMobileAppRelease(params);

  // A company with no release row yet returns HTTP 204; axios surfaces that as
  // an empty-string body. Coerce any falsy body to null so consumers get a clean
  // object-or-null, never the empty string (which fails the object PropTypes).
  return dispatch({
    type: MOBILE_APP_RELEASE_ACTION_TYPE.GET_MOBILE_APP_RELEASE,
    payload: data || null,
  });
});

export const updateMobileAppReleaseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await mobileAppReleaseApi.updateMobileAppRelease(params);

  return dispatch({
    type: MOBILE_APP_RELEASE_ACTION_TYPE.UPDATE_MOBILE_APP_RELEASE,
    payload: data,
  });
});

export const turnOnMobileAppReleaseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await mobileAppReleaseApi.turnOnMobileAppRelease(params);

  return dispatch({
    type: MOBILE_APP_RELEASE_ACTION_TYPE.TURN_ON_MOBILE_APP_RELEASE,
    payload: data,
  });
});

export const getMobileAppReleaseEventsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await mobileAppReleaseApi.getMobileAppReleaseEvents(params);

  return dispatch({
    type: MOBILE_APP_RELEASE_ACTION_TYPE.GET_MOBILE_APP_RELEASE_EVENTS,
    payload: data,
  });
});

// Shares the company-image endpoint rather than carrying its own: the app icon is a full-resolution
// company image and lands in the same public branding blob container.
export const uploadMobileAppIconAction = catchAsyncActionError(
  ({ companyId, file }) =>
    async dispatch => {
      const formData = new FormData();
      formData.append('file', file, file.name);

      const { url } = await dispatch(
        uploadCompanyImageAction({ companyId, type: LogoType.COMPANY, formData }),
      );

      return url;
    },
);

export const getIosPushCertificateStatusAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await mobileAppReleaseApi.getIosPushCertificateStatus(params);

  return dispatch({
    type: MOBILE_APP_RELEASE_ACTION_TYPE.GET_IOS_PUSH_CERTIFICATE_STATUS,
    payload: data || null,
  });
});

// Builds multipart/form-data and POSTs the cert to Skynet.Accounts, then
// re-fetches the status so the UI reflects the new certificate immediately.
export const uploadIosPushCertificateAction = catchAsyncActionError(
  ({ companyId, file, keyPemFile, p12Password, bundleId }) =>
    async dispatch => {
      const formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('bundleId', bundleId);

      if (keyPemFile) {
        const keyPem = await keyPemFile.text();
        formData.append('keyPem', keyPem);
      }

      if (p12Password) {
        formData.append('p12Password', p12Password);
      }

      await mobileAppReleaseApi.uploadIosPushCertificate({ companyId, formData });

      const { data } = await mobileAppReleaseApi.getIosPushCertificateStatus({ companyId });

      return dispatch({
        type: MOBILE_APP_RELEASE_ACTION_TYPE.GET_IOS_PUSH_CERTIFICATE_STATUS,
        payload: data || null,
      });
    },
);
